import { Asset } from '#/graphql/types';
import { Key } from '#/types';

const fields: Key<Asset>[] = [
  'assetTag',
  'serialNumber',
  'state',
  'description',
  'assetTypeId',
  'usefulLife',
  'makeId',
  'modelId',
  'locationId',
  'installDate',
  'acquisitionCostValue',
  'maintenanceCostValue',
  'image',
  'tenantId',
  'condition',
];

export default fields;
